<template>
	<div style="display: contents;">
		<template v-if="buttonComponent == 'v-btn'">
            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        v-on="{ ...tooltip }"
						:fab="params.fab ? params.fab : false"
						:icon="params.fab ? false : true"
						:small="params.small ? true : false"
						:fixed="params.fixed ? true : false"
						:bottom="params.bottom ? true : false"
						:right="params.right ? true : false"
						:dark="params.dark ? true : false"
						:color="params.button_color ? params.button_color : ''"
						@click="openDialog()">
                        <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="params ? params.color : ''">{{ params.icon ? params.icon : 'mdi-magnify' }}</v-icon>
					</v-btn>
				</template>
        		<span>{{ params.tooltip ? params.tooltip : 'Anteprima PDF' }}</span>
    		</v-tooltip>
		</template>

		<v-list-item v-else-if="buttonComponent == 'v-list-item'"
            dense 
            :disabled="disabled"
            @click.stop="openDialog()"
            ripple>
            <v-list-item-icon>
                <v-icon style="font-size: 18px">{{ button.params.icon ? button.params.icon : 'mdi-briefcase' }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ button.params.tooltip ? button.params.tooltip : 'Crea Opportunità' }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-dialog v-model="show" max-width="1000" persistent class="round-card" :fullscreen="fullScreen || $vuetify.breakpoint.smAndDown" scrollable>
            <v-card class="background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Crea Opportunità</p>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native.stop="fullScreen = !fullScreen"><v-icon>fullscreen</v-icon></v-btn>
                </v-card-title>            
                <v-divider></v-divider>
                <v-card-text class="px-1 pb-1">

                    <v-container v-if="show" fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}" class="pt-6">
                        <fields-generator
                            :fieldsset.sync="fieldsset"
                            :model="opportunity"
                            ref="fieldsgenerator"
                            :selectChange="onChange"
                            @loaded="checkDefaultInput"
                            :support="support"
                        ></fields-generator>
                        <small class="px-4">* Indica i campi obbligatori</small>
                    </v-container>
                    <v-divider></v-divider>

                    <template v-if="show">
                        <crud-table-relationship
                            info-url="quotation-products-info"
                            :children="opportunity.products"
                            :parent="opportunity"
                        ></crud-table-relationship>
                        <v-divider></v-divider>
                    </template>

                </v-card-text>

                <v-divider></v-divider>
                
                <v-card-actions style="padding-bottom: calc(16px + env(safe-area-inset-bottom));">
                    <v-spacer></v-spacer>
                    <v-btn text color="info" @click.native.stop="closeDialog()">Annulla
                    </v-btn>
                    <v-btn text color="primary" @click.native.stop="createModel()" :loading="loading">{{params.create ? 'Salva' : 'Modifica'}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import CrudTableRelationship from '@/components/common/CrudTableRelationship'

    export default {
        name: 'generate-opportunity-button',
        components: {
            CrudTableRelationship
        },
        props: {
            button: Object,
		    buttonComponent: {type: String, default : 'v-btn'},
            id: Number,
            model: Object,
            params: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            disabled: Boolean,
        },

        data() {
            return {
                support: {},
                show: false,
                fieldsset: {},
                loading: false,
                opportunity: {},
                fullScreen: false,
                confirmExit: false,
                defaultInput: {'company_id': this.model.company_id}
            }
        },

        methods: {

            closeDialog() {
                this.show = false
            },

            openDialog() {
                this.axios.get('opportunities-trouble/create').then(response => {
                    // get body data
                    this.fieldsset = response.data.fields
                    // Set defaultInput by back-end
                    this.opportunity.products = []
                    this.opportunity.trouble_id = this.model.id

                    _.forEach(this.fieldsset.fields, (value, key) => {
                        if(value.default) {
                            this.$set(this.opportunity, value.key, value.default)
                        }
                    })

                    // Riporta automaticamente la richiesta descrittiva del ticket (ticket o helpdesk)
                    // nella descrizione dell'opportunità, lasciandola modificabile prima del salvataggio.
                    if(this.model.request && !this.opportunity.description) {
                        this.$set(this.opportunity, 'description', this.model.request)
                    }

                    _.forEach(this.defaultInput, (value, key) => {
						this.$set(this.model, key, value)
					})
    
                    this.show = true

                }, response => {

                })
            },

            // Call at change select option
            onChange(field, event) {
                Promise.all(this.$eventBusUtility.fieldsGeneratorConditions(field, event, this.fieldsset, this.opportunity, this.support, this.defaultInput)).then((responses) => {
                    responses.forEach(response => {
                        if(this.opportunity[response.key]) {
                            this.$refs.fieldsgenerator.$refs[response.key][0].$emit('change', this.opportunity[response.key])
                        }
                    })
                })
            },

            //model is trouble
            createModel() {
                this.confirmExit = false

                this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
                    if (!result) {
                        return this.handleValidationErrorAdvanced()
                    }

                    this.loading = true

                    this.axios.post('opportunities-trouble', this.opportunity).then(response => {
                        // get body data
                        this.opportunity = {}
                        this.$store.commit('setModelEdited', false)
                        this.$eventBusUtility.$emit('updateTroubleShow')
                        this.show = false
                        this.loading = false

                    }, response => {
                        this.loading = false
                    })

                }).catch(() => {

                })
            },

            checkDefaultInput() {
                this.$eventBusUtility.checkDefaultInput(this, 'opportunity')
            },
        },
    }
</script>